import { useDispatch } from "react-redux";
import { subscribeNow } from "../../../redux/slices/commonFun";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
export default function SubscribeSection() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");

  const submitSubscribe = async () => {
    if (!email) return;

    try {
      const result = await dispatch(subscribeNow({ email }));
      if (subscribeNow.fulfilled.match(result)) {
        setEmail("");
      }
    } catch (error) {
      toast.error("Subscription failed:", error);
    }
  };
  return (
    <>
      <ToastContainer />
      <section className="w-full font-serif py-16 bg-gradient-to-br from-[#730000] via-[#AF2655] to-[#A3B763]">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white p-12 rounded-lg shadow-lg text-center">
            <h2 className="text-center font-serif text-5xl font-semibold text-[#730000]  max-lg:text-5xl max-sm:text-4xl">
              Subscribe Now
            </h2>

            <p className=" m-auto text-2xl max-lg:text-lg max-sm:text-[15px] font-serif">
              Be the first to know what's happening! We'll let you receive the
              latest information on Proposals as well as offers, tips, and
              updates.
            </p>

            <div className="flex flex-col sm:flex-row max-w-md mx-auto gap-2 mt-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your Email Address"
                className="flex-grow font-serif px-4 py-3 rounded bg-red-50 border border-red-100 focus:outline-none focus:ring-2 focus:ring-red-300"
              />
              <button
                onClick={submitSubscribe}
                className="px-6 py-3 bg-[#730000] text-white font-medium rounded hover:bg-[#ad3c3c] transition-colors"
              >
                SUBSCRIBE
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
